import {
  FACTORING_HEADER_TITLE_CLASS_NAME,
  FACTORING_HEADER_DESCRIPTION_CLASS_NAME,
  DOCUMENT_SUMMARY_TITLE_CLASS_NAME,
  SHOPPING_CART_SUMMARY_TITLE_CLASS_NAME,
  ACCORDION_SUMMARY_TITLE_CLASS_NAME,
  SHOPPING_CART_SUMMARY_TOTAL_TITLE_CLASS_NAME,
  SHOPPING_CART_SUMMARY_VALUE_CLASS_NAME,
  SHOPPING_CART_SUMMARY_CHILD_VALUE_CLASS_NAME,
} from '../../constants/typography';
import { getItauFontFamily } from '../typography-utils';

const HEADER_TITLE_FONT_SIZE = 32;
const HEADER_DESCRIPTION_FONT_SIZE = 16;
const DOCUMENT_SUMMARY_TITLE_FONT_SIZE = 24;

const factoringHeaderTitle = ({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    fontSize: HEADER_TITLE_FONT_SIZE,
    fontWeight: 700,
    lineHeight: '42px',
    color: theme.palette.gray.A700,
  },
});

const factoringHeaderDescription = ({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    fontSize: HEADER_DESCRIPTION_FONT_SIZE,
    fontWeight: 500,
    lineHeight: '24px',
    marginTop: 0,
  },
});

const documentSummaryTitle = ({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    fontSize: DOCUMENT_SUMMARY_TITLE_FONT_SIZE,
    fontWeight: 700,
    lineHeight: '32px',
  },
});

const shoppingCartSummaryTitle = ({ theme }) => ({
  color: theme.palette.gray.A600,
  fontSize: '24px',
  fontWeight: 500,
  lineHeight: '32px',
  textAlign: 'left',
  width: '100%',
});

const accordionSummaryTitle = () => ({
  fontSize: '20px',
  fontWeight: 500,
});

const shoppingCartSummaryTotalTitle = ({ theme }) => ({
  color: theme.palette.secondary.A500,
});

const shoppingCartSummaryValue = () => ({
  fontSize: '18px',
});

const shoppingCartSummaryChildValue = () => ({
  fontSize: '16px',
});

const MuiTypography = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      ...(ownerState.sx?.fontSize !== undefined && {
        fontFamily: getItauFontFamily(ownerState.sx.fontSize),
      }),
      [`&.${FACTORING_HEADER_TITLE_CLASS_NAME}`]: factoringHeaderTitle({ theme }),
      [`&.${FACTORING_HEADER_DESCRIPTION_CLASS_NAME}`]: factoringHeaderDescription({ theme }),
      [`&.${DOCUMENT_SUMMARY_TITLE_CLASS_NAME}`]: documentSummaryTitle({ theme }),
      [`&.${SHOPPING_CART_SUMMARY_TITLE_CLASS_NAME}`]: shoppingCartSummaryTitle({ theme }),
      [`&.${ACCORDION_SUMMARY_TITLE_CLASS_NAME}`]: accordionSummaryTitle({ theme }),
      [`&.${SHOPPING_CART_SUMMARY_TOTAL_TITLE_CLASS_NAME}`]: shoppingCartSummaryTotalTitle({ theme }),
      [`&.${SHOPPING_CART_SUMMARY_VALUE_CLASS_NAME}`]: shoppingCartSummaryValue(),
      [`&.${SHOPPING_CART_SUMMARY_CHILD_VALUE_CLASS_NAME}`]: shoppingCartSummaryChildValue(),
    }),
  },
};

export default MuiTypography;
